import { render, staticRenderFns } from "./MailSent.vue?vue&type=template&id=3c926b10"
import script from "./MailSent.vue?vue&type=script&lang=js"
export * from "./MailSent.vue?vue&type=script&lang=js"
import style0 from "./MailSent.vue?vue&type=style&index=0&id=3c926b10&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports